import{__awaiter as r}from"../../../../../node_modules/tslib/tslib.es6.js";import{shopifyStorefrontClientWrapper as o}from"../../../../../lib/clients.js";import{handleError as t}from"../../../../../lib/error-handler.js";import{gql as e}from"graphql-request";import{shopifyCollectionProductsIdsToUnlikelyCollectionProductsIds as s}from"../utils/serializers.js";import{PAGE_INFO_FRAGMENT as d}from"../../fragments/page-info.js";import u from"../../../../../lib/page-info.js";const i=e`
  query CollectionProductsIds(
    $handle: String
    $id: ID
    $language: LanguageCode
    $country: CountryCode
    $productsFirst: Int
    $productsAfter: String
    $productsBefore: String
    $productsSortKey: ProductCollectionSortKeys
    $productsReverse: Boolean!
    $productsFilters: [ProductFilter!]
  ) @inContext(language: $language, country: $country) {
    collection(handle: $handle, id: $id) {
      products(
        first: $productsFirst
        after: $productsAfter
        before: $productsBefore
        sortKey: $productsSortKey
        reverse: $productsReverse
        filters: $productsFilters
      ) {
        nodes {
          id
        }
        ${d}
      }
    }
  }
`,l=o(((o,e)=>r(void 0,void 0,void 0,(function*(){var r,d,l;const{language:n,country:c}=null!=e?e:{},p="handle"in e?{handle:e.handle}:{id:e.id},a=yield o.request(i,Object.assign(Object.assign({},p),{language:n,country:c,includeProducts:e.productsFirst>0,productsFirst:e.productsFirst,productsAfter:e.productsAfter,productsFilters:null!==(r=e.productsFilters)&&void 0!==r?r:[],productsBefore:e.productsBefore,productsSortKey:e.productsSortKey,productsReverse:null!==(d=e.productsReverse)&&void 0!==d&&d})),{collection:f}=null!=a?a:{},{pageInfo:g}=null!==(l=null==f?void 0:f.products)&&void 0!==l?l:{};return{errors:t(null==a?void 0:a.errors),collectionProductsIds:s(f),productsIdsPageInfo:g?u(g):null}}))));export{l as sfCollectionProductsIds};
//# sourceMappingURL=collectionProductsIds.js.map
